import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Outlet Icon Style 02 - Power (Material Symbol)
 * A power button style icon
 * - isOn = true: 綠色實心
 * - isOn = false: 灰色空心
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:power_settings_new
 */
export const Style02_Power: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-green-500' : 'text-slate-400';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      power_settings_new
    </span>
  );
};

export default Style02_Power;
